import { contentValidateForm } from './ContentValidateForm';

export const switchProjectTabs = () => {
  const tabs = document.querySelectorAll('.js-project-tabs');
 
  tabs && tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const listTypeClass = `js-${tab.getAttribute('data-type')}-all`;
      const currentWrapper = document.querySelector(`.${listTypeClass}`);
      const lastWrapper = document.querySelector(`.project__list:not(.${listTypeClass}`);
      lastWrapper.classList.add('project__hide');
      currentWrapper.classList.remove('project__hide');
      document.querySelector(`.js-project-tabs:not([data-type=${tab.getAttribute('data-type')}])`).classList.remove('active');
      tab.classList.add('active');
    });
  });
}



export const addAndEditCollabValidations = () => {  
  const submitForm = document.querySelector('.js-edit-project-form');
  const editBtn = document.getElementById('js-edit-submit');
  const submitBtn = document.getElementById('js-edit-project');
  const message = document.getElementById('js-project-message');
  const deleteCollab = document.getElementById('js-delete-collab');

  // hide afd_message
  message && setTimeout(() => message.classList.add('project__hide'), 5000)

  // logic disabled edit 
  editBtn && editBtn.addEventListener('click', () => {
    let event = editBtn.getAttribute('data-event');
    let name = editBtn.innerHTML;
    let dropAreas = document.querySelectorAll('.js-drop__area')
    if (event === 'edit') {
      changeFormBehaviour(editBtn, 'cancel', name)
      submitBtn.classList.remove('project__hide')
      dropAreas && dropAreas.forEach(area => area.classList.remove('project__drop-area-disabled'))
    } else if (event === 'cancel') {
      changeFormBehaviour(editBtn, 'edit', name)
      submitBtn.classList.add('project__hide')
      dropAreas && dropAreas.forEach(area => area.classList.add('project__drop-area-disabled'))
    }
  });

  const changeFormBehaviour = (editBtn, event, name) => {
    submitForm && [...submitForm.elements].forEach(el =>  { 
      if (['INPUT', 'TEXTAREA'].includes(el.tagName) && el.type !== 'hidden') {
        el.disabled === true ? (el.disabled = false) : (el.disabled = true)
      }
    });
    editBtn.setAttribute('data-event', event);
    editBtn.innerHTML = editBtn.getAttribute('data-name');
    editBtn.setAttribute('data-name', name)
  }

  deleteCollab && deleteCollab.addEventListener('click', () => {
    const modalId = deleteCollab.getAttribute('data-modalId')
    AFD.modals.open(`#${modalId}`);
  })

  if (submitForm) {
    contentValidateForm(
      submitForm,
      {
        validations: {
          '#expert_category_headline': 'required',
          '#expert_category_project_images_attributes_0_image': 'image',
          '#expert_category_project_images_attributes_0_description': 'required',
          '#expert_category_project_images_attributes_1_image': 'image',
          '#expert_category_project_images_attributes_1_description': 'required'
        },
        cta: '#js-edit-project',
        handlerEdit: true
      }
    )

    if (submitForm.getAttribute('data-action') === 'action') {
        setTimeout(() => submitBtn.classList.add('afd-btn--not-allowed'), 2000 )
    }
  }
}
